

export const takeDataArray = <T = any>(raw: any): T[] => {
    // legacy: { data: [...] } ; v2: [...] или {data:[...]}
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.data)) return raw.data;
    return [];
};

export const takeDataObject = <T = any>(raw: any): T => {
    // legacy: { data: {...} } ; v2: {...}
    if (raw?.data && typeof raw.data === 'object') return raw.data as T;
    return raw as T;
};


